import React, { useEffect, useState } from 'react';
import { InputText } from 'component-library/index';
import { IInputTextProps } from '../../../component-library/atoms/InputText/InputText';

export interface IMiddleInitialFieldProps {
    name?: string;
    label?: string | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactElement<any, string | React.JSXElementConstructor<any>>[];
    inputClass?: string;
    value?: string;
    disabled?: boolean;
    setValueCallback?: THandlerFunction;
    alternate?: boolean;
    onFocusCallback?: (((value: React.FocusEvent<HTMLInputElement>) => void) & React.FocusEventHandler<any>);
    onBlurCallback?: (((value: React.FocusEvent<HTMLInputElement>) => void) & React.FocusEventHandler<any>);
    ref?: React.MutableRefObject<any>;
    useSuccessIcon?: boolean;
    showSuccessIcon?: boolean;
    removeAsterisk?: boolean;
    isAUInEditMode?: boolean;
}
 
export const MiddleInitialField = (props:IMiddleInitialFieldProps & React.HTMLAttributes<HTMLInputElement>) => {
    const [state, setState] = useState<IInputTextProps['state']>('neutral');
    
    const focusEventHandler = (e: React.FocusEvent<HTMLInputElement>) => {
        if (e.type === 'blur') {
            setState(props.value ? 'success' : 'neutral');
            props.onBlurCallback && props.onBlurCallback(e);
        } else if (e.type === 'focus') {
            setState('neutral');
            props.onFocusCallback && props.onFocusCallback(e);
        }
    };

    const formattedMiddleInitial = (value: string) => {
        const initial = value.replace(/[^a-zA-Z]/g, '').toUpperCase();

        if (initial.length > 1) {
            return initial.substring(0, 1);
        }

        return initial;
    };
    const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (props.value !== event.target.value) {
            setState('neutral');
        }

        handleFormatValue(event.target.value);
    };

    const handleFormatValue = (newVal: string) => {
        props.setValueCallback && props.setValueCallback(formattedMiddleInitial(newVal));
    };

    useEffect(() => {
        if(!props.isAUInEditMode) {
            return;
        }
        setState('neutral');
    }, [props.isAUInEditMode]);
    
 
    return (
        <React.Fragment>
            <InputText
                ref={props.ref}
                name={props.name}
                label={props.label}
                id={props.id}
                maxLength={1}
                value={props.value}
                setValue={handleFormatValue}
                onFocus={focusEventHandler}
                onBlur={focusEventHandler}
                onChange={changeHandler}
                disabled={props.disabled}
                state={state}
                containerId='middleInitial-field-container'   
            />
        </React.Fragment>
 
        
    );
};